import { render, staticRenderFns } from "./HotClients.vue?vue&type=template&id=1f6cc62c"
import script from "./HotClients.vue?vue&type=script&lang=js"
export * from "./HotClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports